import { useState } from "react";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { RepSelect, RoleSelect } from "./UserSelects";

const BLANK = { name: "", username: "", password: "", role: "User", rep_id: "" };
const REQUIRED = [["name", "Full name"], ["username", "Username"], ["password", "Password"]];

const fieldFor = (msg) => {
  if (msg.startsWith("Full name")) return "name";
  if (msg.startsWith("Username")) return "username";
  if (msg.startsWith("Password")) return "password";
  return "form";
};

const validate = (f) => {
  const missing = REQUIRED.find(([k]) => !f[k].trim());
  if (missing) return { [missing[0]]: `${missing[1]} is required` };
  if (f.password.length < 8) return { password: "Password must be at least 8 characters" };
  return {};
};

const TextField = ({ k, label, f, errors, set, type = "text" }) => (
  <label className="block"><span className="field-label">{label}</span>
    <input data-testid={`users-add-${k}-input`} type={type} value={f[k]} autoComplete="off" onChange={(e) => set(k, e.target.value)}
      className={`inp ${errors[k] ? "inp-invalid" : ""}`} />
    {errors[k] && <span data-testid={`users-add-${k}-error`} className="field-error mt-1 block">{errors[k]}</span>}
  </label>
);

export const AddUserForm = ({ reps, onAdded }) => {
  const [f, setF] = useState(BLANK);
  const [errors, setErrors] = useState({});
  const set = (k, v) => { setF((p) => ({ ...p, [k]: v })); setErrors({}); };

  const submit = async (e) => {
    e.preventDefault();
    const errs = validate(f);
    if (Object.keys(errs).length) return setErrors(errs);
    try {
      const { data } = await api.post("/users", { ...f, rep_id: f.rep_id || null });
      onAdded(data);
      setF(BLANK);
      toast.success(`${data.name} added`);
    } catch (err) {
      const msg = errMsg(err);
      setErrors({ [fieldFor(msg)]: msg });
    }
  };

  return (
    <form onSubmit={submit} data-testid="users-add-form" className="space-y-3 rounded-2xl border border-slate-800 bg-slate-900 p-4">
      <h2 className="section-title">Add user</h2>
      <div className="grid gap-3 sm:grid-cols-3">
        <TextField k="name" label="Full name" f={f} errors={errors} set={set} />
        <TextField k="username" label="Username" f={f} errors={errors} set={set} />
        <TextField k="password" label="Password" type="password" f={f} errors={errors} set={set} />
        <RoleSelect testid="users-add-role-select" value={f.role} onChange={(v) => set("role", v)} />
        <RepSelect testid="users-add-rep-select" reps={reps} value={f.rep_id} onChange={(v) => set("rep_id", v)} />
        <div className="flex items-end">
          <button type="submit" data-testid="users-add-submit-btn" className="btn-primary w-full"><UserPlus className="h-4 w-4" /> Add user</button>
        </div>
      </div>
      {errors.form && <p data-testid="users-add-error" className="field-error">{errors.form}</p>}
    </form>
  );
};
